import { useEffect, useState } from 'react'

export const DEBOUNCE_BUSQUEDA_MS = 350

/**
 * Devuelve el valor recién cuando dejó de cambiar durante `delay` ms.
 *
 * Se usa para que la grilla filtre cuando el usuario deja de escribir y no en
 * cada tecla (criterio 7). El input sigue siendo controlado por el valor sin
 * debounce, así que la escritura no se siente demorada.
 *
 * @param {*} valor
 * @param {number} delay
 */
export function useDebouncedValue(valor, delay = DEBOUNCE_BUSQUEDA_MS) {
  const [valorDebounced, setValorDebounced] = useState(valor)

  useEffect(() => {
    const temporizador = setTimeout(() => setValorDebounced(valor), delay)

    return () => clearTimeout(temporizador)
  }, [valor, delay])

  return valorDebounced
}
